import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isModernPullRequestExperienceEnabled(): boolean {
  return isFeatureEnabled('updated_pull_request_header')
}
